const dev = {
    aws: {
        region: "us-east-1"
    },
    mixpanel: {
        token: "4f320523c5963d10a9bc7988758002ba"
    },
    cognito: {
        userpool_id: null,
        client_id: null
    },
    api: {
        endpoint:
            null
    },
    SENTRY_DSN:
        "https://840cb84f860542afbc916811e7598d07@o105963.ingest.sentry.io/4504005685936128"
};

//Put the universal vars in here
export default {
    ...dev
};
